<template lang="">
     <v-container>
        <v-row 
            no-gutters
        >
        
            <!--Referencia_Auto_Variador_Ventilador-->
            <referencia-velocidad
            titulo="Referencia Velocidad Soplante"
            :datos="datos"
            topic="Referencia_Auto_Variador_Ventilador"
            ></referencia-velocidad>

        </v-row>


        <v-row 
            no-gutters
            class="blue-grey lighten-5"
        >
            <!--Referencia_Descarga_Variador_Ventilador-->
            <referencia-velocidad
            titulo="Referencia Velocidad Soplante Descarga"
            :datos="datos"
            topic="Referencia_Descarga_Variador_Ventilador"
            ></referencia-velocidad>
        </v-row>
        <v-row 
            no-gutters
        >
            <!--Referencia_Auto_Variador_Tromel-->
            <referencia-velocidad
            titulo="Referencia Velocidad Tromel"
            :datos="datos"
            topic="Referencia_Auto_Variador_Tromel"
            ></referencia-velocidad>
        </v-row>
        <v-row 
            no-gutters
            class="blue-grey lighten-5"
        >
        
        <!--Referencia_Auto_Variador_Tromel-->
            <referencia-velocidad
            titulo="Referencia Velocidad Tromel Posicionador"
            :datos="datos"
            topic="Referencia_Pos_Lenta_Variador_Tromel"
            ></referencia-velocidad>
        </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ReferenciaVelocidad from "@/components/HMI/ReferenciasVelocidad/ReferenciaVelocidad.vue";
export default {
    components:{
        ReferenciaVelocidad
    },

    created() {
        this.doSubscribe('REGULADORES2')
        this.client.on('message', (topic, message) => {
            // console.log("HA RECIBIDO UN MENSAJITO DE REGULADORES 2")
            //Datos relativos al ensayo (realizado por, lote MP, lote bolson, Cuerpos extraños,kg membrana y lote membrana)
            if(topic=="REGULADORES2"){
                this.tratar_mensaje(message)
            }
          //Limpiar datos de produccion

        })
    },//fin created
    methods: {
        ...mapActions('nodered',['doSubscribe']),
        tratar_mensaje(mensaje){
            if(mensaje.length>0)this.datos= JSON.parse(mensaje);
        }
    },//fin metodos
    data() {
        return {
            datos:{}
        }
    },
    computed: {
        ...mapState("nodered",['client']),
    },
}
</script>
<style lang="">
    
</style>